export const lineHeightList = [1, 1.2, 1.5, 1.75, 2, 2.5, 3, 4];